module.exports = __webpack_public_path__ + "static/media/cortex-logo.d02660dd.png";